export default __webpack_public_path__ + "static/media/Settings.4d6653e8.svg";